/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './symptom.reducer';

export const SymptomDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const symptomEntity = useAppSelector(state => state.symptom.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="symptomDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.symptom.detail.title">Symptom</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.symptom.id">Id</Translate>
            </span>
          </dt>
          <dd>{symptomEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tinyMedicRestApp.symptom.name">Name</Translate>
            </span>
          </dt>
          <dd>{symptomEntity.name}</dd>
          <dt>
            <span id="gender">
              <Translate contentKey="tinyMedicRestApp.symptom.gender">Gender</Translate>
            </span>
          </dt>
          <dd>{symptomEntity.gender}</dd>
          <dt>
            <span id="widgetType">
              <Translate contentKey="tinyMedicRestApp.symptom.widgetType">Widget Type</Translate>
            </span>
          </dt>
          <dd>{symptomEntity.widgetType}</dd>
          <dt>
            <span id="startDate">
              <Translate contentKey="tinyMedicRestApp.symptom.startDate">Start Date</Translate>
            </span>
          </dt>
          <dd>{symptomEntity.startDate}</dd>
          <dt>
            <span id="endDate">
              <Translate contentKey="tinyMedicRestApp.symptom.endDate">End Date</Translate>
            </span>
          </dt>
          <dd>{symptomEntity.endDate}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.symptom.active">Active</Translate>
            </span>
          </dt>
          <dd>{symptomEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="draft">
              <Translate contentKey="tinyMedicRestApp.symptom.draft">Draft</Translate>
            </span>
          </dt>
          <dd>{symptomEntity.draft ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.symptom.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{symptomEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.symptom.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{symptomEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.symptom.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{symptomEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.symptom.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{symptomEntity.timestampEntry}</dd>
          <dt>
            <span id="ucid">
              <Translate contentKey="tinyMedicRestApp.symptom.ucid">Ucid</Translate>
            </span>
          </dt>
          <dd>{symptomEntity.ucid}</dd>
        </dl>
        <Button tag={Link} to="/symptom" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/symptom/${symptomEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default SymptomDetail;
